/**
 * @generated SignedSource<<caa3083d066cdf81f8acba3b253f345c>>
 * @relayHash 5f34317facc3c748f97a1d7a1d1aac25
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 929cb40c8421910923cc1b654f8601af59d22ab4f38d19384d91ed4677abf87a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchIssueStatusCategory = "DONE" | "INDETERMINATE" | "NEW" | "OPEN" | "UNDEFINED" | "%future added value";
export type SearchLinkedEntityGranularity = "ALL_MATCHING_MESSAGES" | "DEFAULT" | "FULL_THREAD" | "ONLY_LINKED_ENTITIES" | "%future added value";
export type SearchLoomVideoType = "ASYNC_VIDEO" | "MEETING_RECORDING" | "%future added value";
export type SearchParticipantType = "COMMENTED" | "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "SHARED" | "VIEWED" | "%future added value";
export type SearchProjectType = "business" | "customer_service" | "product_discovery" | "service_desk" | "software" | "%future added value";
export type SearchSalesforceAttributeFilterOperator = "BETWEEN" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "%future added value";
export type SearchSalesforceAttributeFilterSource = "CUSTOM_PROPERTIES_DATE" | "CUSTOM_PROPERTIES_KEYWORD" | "CUSTOM_PROPERTIES_NUMBER" | "RELATIONSHIPS" | "%future added value";
export type SearchServiceNowAttributeFilterOperator = "BETWEEN" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "%future added value";
export type SearchServiceNowAttributeFilterSource = "ADD_ON_PROPERTIES_DATE" | "KEYWORD" | "RELATIONSHIPS" | "%future added value";
export type SearchSortOrder = "ASC" | "DESC" | "%future added value";
export type SearchThirdPartyRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null;
  participants?: SearchParticipants | null;
  range?: SearchCommonRangeFilter | null;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null;
  lastModified?: SearchCommonRangeFilterFields | null;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null;
  lt?: string | null;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null;
  containerARIs?: ReadonlyArray<string> | null;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null> | null;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null;
  contributorsFilter?: ReadonlyArray<string> | null;
  creatorsFilter?: ReadonlyArray<string> | null;
  isVerified?: boolean | null;
  labelsFilter?: ReadonlyArray<string> | null;
  mentions?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  pageStatus?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null> | null;
  spacesFilter?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchJiraFilter = {
  boardFilter?: SearchBoardFilter | null;
  issueFilter?: SearchJiraIssueFilter | null;
  projectFilter?: SearchJiraProjectFilter | null;
};
export type SearchBoardFilter = {
  negateProjectFilter?: boolean | null;
  projectARI?: string | null;
  userARI?: string | null;
};
export type SearchJiraIssueFilter = {
  assigneeARIs?: ReadonlyArray<string> | null;
  commenterARIs?: ReadonlyArray<string> | null;
  issueLabels?: ReadonlyArray<string> | null;
  issueTypeIDs?: ReadonlyArray<string> | null;
  issueTypes?: ReadonlyArray<string> | null;
  projectARIs?: ReadonlyArray<string> | null;
  reporterARIs?: ReadonlyArray<string> | null;
  statusCategories?: ReadonlyArray<SearchIssueStatusCategory> | null;
  watcherARIs?: ReadonlyArray<string> | null;
};
export type SearchJiraProjectFilter = {
  projectType?: SearchProjectType | null;
  projectTypes?: ReadonlyArray<SearchProjectType> | null;
};
export type SearchLoomFilters = {
  folderIds?: ReadonlyArray<string> | null;
  playlistIds?: ReadonlyArray<string> | null;
  spaceIds?: ReadonlyArray<string> | null;
  tagNames?: ReadonlyArray<string> | null;
  videoTypes?: ReadonlyArray<SearchLoomVideoType> | null;
};
export type SearchAssetsFilter = {
  objectSchemaFilter?: SearchAssetsObjectSchemaFilter | null;
  objectTypeFilter?: SearchAssetsObjectTypeFilter | null;
};
export type SearchAssetsObjectSchemaFilter = {
  schemaARIs?: ReadonlyArray<string> | null;
};
export type SearchAssetsObjectTypeFilter = {
  typeARIs?: ReadonlyArray<string> | null;
};
export type SearchMercuryFilter = {
  ancestorIds?: ReadonlyArray<string> | null;
  focusAreaTypeIds?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
};
export type SearchTalentFilter = {
  employmentTypes?: ReadonlyArray<string> | null;
  focusAreas?: ReadonlyArray<string> | null;
  jobFamilies?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  statuses?: ReadonlyArray<string> | null;
  teams?: ReadonlyArray<string> | null;
};
export type SearchCompassFilter = {
  componentFilter?: SearchCompassComponentFilter | null;
};
export type SearchCompassComponentFilter = {
  componentStates: ReadonlyArray<string>;
};
export type SearchThirdPartyFilter = {
  additionalTexts?: ReadonlyArray<string> | null;
  ancestorAris?: ReadonlyArray<string> | null;
  assignees?: ReadonlyArray<string> | null;
  containerAris?: ReadonlyArray<string> | null;
  containerNames?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  createdBy?: ReadonlyArray<string> | null;
  excludeSubtypes?: ReadonlyArray<string> | null;
  gitFilters?: SearchGitFilters | null;
  gongFilters?: SearchGongFilters | null;
  integrations?: ReadonlyArray<string> | null;
  labels?: ReadonlyArray<string> | null;
  lastUpdatedBy?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchThirdPartyRangeFilter | null> | null;
  salesforceFilters?: SearchSalesforceFilters | null;
  serviceNowFilters?: SearchServiceNowFilters | null;
  subtypes?: ReadonlyArray<string | null> | null;
  teamsFilters?: SearchTeamsFilters | null;
  thirdPartyProducts?: ReadonlyArray<SearchThirdPartyProduct> | null;
  thirdPartyTypes?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchGitFilters = {
  pullRequestStatus?: ReadonlyArray<string> | null;
  repoName?: ReadonlyArray<string> | null;
  reviewer?: ReadonlyArray<string> | null;
};
export type SearchGongFilters = {
  crmAccountName?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyRangeFilter = {
  field: SearchThirdPartyRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchSalesforceFilters = {
  attributeFilters?: ReadonlyArray<SearchSalesforceAttributeFilter> | null;
  campaignStatuses?: ReadonlyArray<string> | null;
  caseStatuses?: ReadonlyArray<string> | null;
  closeDate?: string | null;
  eventTypes?: ReadonlyArray<string> | null;
  isClosed?: boolean | null;
  knowledgeArticlePublishStatuses?: ReadonlyArray<string> | null;
  leadStatuses?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  stage?: ReadonlyArray<string> | null;
  taskStatuses?: ReadonlyArray<string> | null;
  taskTypes?: ReadonlyArray<string> | null;
};
export type SearchSalesforceAttributeFilter = {
  field: string;
  from?: string | null;
  operator: SearchSalesforceAttributeFilterOperator;
  source: SearchSalesforceAttributeFilterSource;
  to?: string | null;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type SearchServiceNowFilters = {
  attributeFilters?: ReadonlyArray<SearchServiceNowAttributeFilter> | null;
  owners?: ReadonlyArray<string> | null;
};
export type SearchServiceNowAttributeFilter = {
  field: string;
  from?: string | null;
  operator: SearchServiceNowAttributeFilterOperator;
  source: SearchServiceNowAttributeFilterSource;
  to?: string | null;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type SearchTeamsFilters = {
  attachmentFileTypes?: ReadonlyArray<string> | null;
  hasAttachment?: boolean | null;
  hasLink?: boolean | null;
  messageType?: string | null;
  workspaceName?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyProduct = {
  channels?: ReadonlyArray<string | null> | null;
  connectionIds?: ReadonlyArray<string> | null;
  connectorSources?: ReadonlyArray<string> | null;
  connectorSourcesImpersonationEnabled?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  datasourceId?: string | null;
  entities?: ReadonlyArray<string> | null;
  integrationId?: string | null;
  linkedEntities?: ReadonlyArray<string> | null;
  linkedEntityGranularity?: SearchLinkedEntityGranularity | null;
  product?: string | null;
  providerId?: string | null;
  subtypes?: ReadonlyArray<string> | null;
};
export type SearchSortInput = {
  field: string;
  key?: string | null;
  order: SearchSortOrder;
};
export type SearchExperimentLayer = {
  definitions?: ReadonlyArray<SearchLayerDefinition | null> | null;
  layerId?: string | null;
  name?: string | null;
  shadowId?: string | null;
};
export type SearchLayerDefinition = {
  abTestId?: string | null;
  armId?: string | null;
  connectorSources?: ReadonlyArray<string | null> | null;
  entity?: string | null;
  integrationARI?: string | null;
  layerId?: string | null;
  providerId?: string | null;
  shadowId?: string | null;
  statsigLayerId?: string | null;
  subEntity?: string | null;
};
export type SearchMatchingLayerExperimentsMetadata = {
  matchingLayers?: ReadonlyArray<SearchMatchingLayer | null> | null;
};
export type SearchMatchingLayer = {
  layerName?: string | null;
  layerType?: string | null;
};
export type searchResultsAsyncQuery$variables = {
  after?: string | null;
  assetsFilters?: SearchAssetsFilter | null;
  cloudIdARIs: ReadonlyArray<string>;
  commonFilters?: SearchCommonFilter | null;
  compassFilters?: SearchCompassFilter | null;
  confluenceFilters?: SearchConfluenceFilter | null;
  deferFederatedResults: boolean;
  disableQueryReplacement?: boolean | null;
  enableHighlighting?: boolean | null;
  enableRelevanceDebugging?: boolean | null;
  entities: ReadonlyArray<string>;
  expectResult?: boolean | null;
  experience: string;
  experimentId?: string | null;
  experimentLayers?: ReadonlyArray<SearchExperimentLayer | null> | null;
  fanoutExperimentCohort?: string | null;
  includeCaseEmbeddedComments?: boolean | null;
  includeCodeSearch?: boolean | null;
  includeDatasourceId?: boolean | null;
  includeFastJiraHydration?: boolean | null;
  includeJiraLiteModeFields?: boolean | null;
  includeMercuryAsk?: boolean | null;
  includeNavBoostScore?: boolean | null;
  includeOriginalEntityType?: boolean | null;
  includePassionfruitAsk?: boolean | null;
  includePositions?: boolean | null;
  includeRisk?: boolean | null;
  includeThirdPartyId?: boolean | null;
  jiraFilters?: SearchJiraFilter | null;
  limit: number;
  loomFilters?: SearchLoomFilters | null;
  matchingLayerExperimentsMetadata?: SearchMatchingLayerExperimentsMetadata | null;
  mercuryFilters?: SearchMercuryFilter | null;
  query: string;
  queryVersion?: number | null;
  searchSessionId?: string | null;
  sessionId?: string | null;
  shadowExperimentId?: string | null;
  sort?: ReadonlyArray<SearchSortInput | null> | null;
  sourceProduct?: string | null;
  talentFilters?: SearchTalentFilter | null;
  tenantId: string;
  thirdPartyFilters?: SearchThirdPartyFilter | null;
  useCaseId?: string | null;
};
export type searchResultsAsyncQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData">;
};
export type searchResultsAsyncQuery = {
  response: searchResultsAsyncQuery$data;
  variables: searchResultsAsyncQuery$variables;
};
({
  "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
  "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider": includeSlackWorkspaceMetadata_provider,
  "__relay_internal__pv__isleadnounenabledrelayprovider": isLeadNounEnabled_provider,
  "__relay_internal__pv__isleaduserastitleenabledrelayprovider": isLeadUserAsTitleEnabled_provider,
  "__relay_internal__pv__isslacktopreactionenabledrelayprovider": includeSlackTopReaction_provider,
  "__relay_internal__pv__skiplinkeduserhydrationrelayprovider": skipLinkedUserHydration_provider,
  "__relay_internal__pv__isprojectrendererenabledrelayprovider": isProjectRendererEnabled_provider,
  "__relay_internal__pv__ismetadatacontentenabledrelayprovider": includeMetadataContent_provider
} as {
  readonly __relay_internal__pv__isassetsenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isleadnounenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isleaduserastitleenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__ismetadatacontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isprojectrendererenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isslacktopreactionenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isslackworkspacemetadataenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__skiplinkeduserhydrationrelayprovider: {
    readonly get: () => boolean;
  };
});

import includeAssets_provider from './../is-assets-enabled.relayprovider';
import skipLinkedUserHydration_provider from './../search-result/search-result-renderer/common/thread-body/thread-message/skip-linked-user-hydration.relayprovider';
import isLeadNounEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-lead/is-lead-noun-enabled.relayprovider';
import isLeadUserAsTitleEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-lead/is-lead-user-as-title-enabled.relayprovider';
import includeSlackWorkspaceMetadata_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-message/../is-slack-workspace-metadata-enabled.relayprovider';
import includeSlackTopReaction_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-message/is-slack-top-reaction-enabled.relayprovider';
import isProjectRendererEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-project/is-project-renderer-enabled.relayprovider';
import includeMetadataContent_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-video/is-metadata-content-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetsFilters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdARIs"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commonFilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compassFilters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluenceFilters"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deferFederatedResults"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disableQueryReplacement"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableHighlighting"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableRelevanceDebugging"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entities"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expectResult"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentId"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentLayers"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fanoutExperimentCohort"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeCaseEmbeddedComments"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeCodeSearch"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeDatasourceId"
},
v19 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFastJiraHydration"
},
v20 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeJiraLiteModeFields"
},
v21 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeMercuryAsk"
},
v22 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeNavBoostScore"
},
v23 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeOriginalEntityType"
},
v24 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePassionfruitAsk"
},
v25 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePositions"
},
v26 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRisk"
},
v27 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeThirdPartyId"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraFilters"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loomFilters"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "matchingLayerExperimentsMetadata"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mercuryFilters"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryVersion"
},
v35 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchSessionId"
},
v36 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v37 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shadowExperimentId"
},
v38 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v39 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceProduct"
},
v40 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "talentFilters"
},
v41 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v42 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "thirdPartyFilters"
},
v43 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useCaseId"
},
v44 = {
  "kind": "Variable",
  "name": "useCaseId",
  "variableName": "useCaseId"
},
v45 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "queryVersion",
        "variableName": "queryVersion"
      },
      {
        "kind": "Variable",
        "name": "searchSessionId",
        "variableName": "searchSessionId"
      },
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      },
      {
        "kind": "Variable",
        "name": "sourceProduct",
        "variableName": "sourceProduct"
      }
    ],
    "kind": "ObjectValue",
    "name": "analytics"
  },
  {
    "kind": "Variable",
    "name": "disableQueryReplacement",
    "variableName": "disableQueryReplacement"
  },
  {
    "kind": "Variable",
    "name": "enableHighlighting",
    "variableName": "enableHighlighting"
  },
  {
    "kind": "Variable",
    "name": "enableRelevanceDebugging",
    "variableName": "enableRelevanceDebugging"
  },
  {
    "kind": "Variable",
    "name": "expectResult",
    "variableName": "expectResult"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "experimentId",
        "variableName": "experimentId"
      },
      {
        "kind": "Variable",
        "name": "experimentLayers",
        "variableName": "experimentLayers"
      },
      {
        "kind": "Variable",
        "name": "shadowExperimentId",
        "variableName": "shadowExperimentId"
      }
    ],
    "kind": "ObjectValue",
    "name": "experimentContext"
  },
  {
    "kind": "Variable",
    "name": "fanoutExperimentCohort",
    "variableName": "fanoutExperimentCohort"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "assetsFilters",
        "variableName": "assetsFilters"
      },
      {
        "kind": "Variable",
        "name": "commonFilters",
        "variableName": "commonFilters"
      },
      {
        "kind": "Variable",
        "name": "compassFilters",
        "variableName": "compassFilters"
      },
      {
        "kind": "Variable",
        "name": "confluenceFilters",
        "variableName": "confluenceFilters"
      },
      {
        "kind": "Variable",
        "name": "entities",
        "variableName": "entities"
      },
      {
        "kind": "Variable",
        "name": "jiraFilters",
        "variableName": "jiraFilters"
      },
      {
        "kind": "Variable",
        "name": "locations",
        "variableName": "cloudIdARIs"
      },
      {
        "kind": "Variable",
        "name": "loomFilters",
        "variableName": "loomFilters"
      },
      {
        "kind": "Variable",
        "name": "mercuryFilters",
        "variableName": "mercuryFilters"
      },
      {
        "kind": "Variable",
        "name": "talentFilters",
        "variableName": "talentFilters"
      },
      {
        "kind": "Variable",
        "name": "thirdPartyFilters",
        "variableName": "thirdPartyFilters"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "matchingLayerExperimentsMetadata",
    "variableName": "matchingLayerExperimentsMetadata"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  (v44/*: any*/)
],
v46 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v47 = {
  "kind": "ScalarField",
  "name": "id"
},
v48 = {
  "kind": "ScalarField",
  "name": "description"
},
v49 = {
  "condition": "includeDatasourceId",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "datasourceId"
    }
  ]
},
v50 = {
  "kind": "ScalarField",
  "name": "connectorType"
},
v51 = {
  "kind": "ScalarField",
  "name": "title"
},
v52 = {
  "kind": "ScalarField",
  "name": "url"
},
v53 = {
  "kind": "ScalarField",
  "name": "type"
},
v54 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v55 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v56 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v57 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v58 = {
  "kind": "ScalarField",
  "name": "value"
},
v59 = {
  "kind": "ScalarField",
  "name": "label"
},
v60 = [
  (v59/*: any*/)
],
v61 = {
  "kind": "ScalarField",
  "name": "key"
},
v62 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v63 = {
  "kind": "ScalarField",
  "name": "name"
},
v64 = [
  (v63/*: any*/)
],
v65 = {
  "kind": "ScalarField",
  "name": "lastModified"
},
v66 = {
  "kind": "ScalarField",
  "name": "total"
},
v67 = {
  "kind": "ScalarField",
  "name": "count"
},
v68 = [
  (v67/*: any*/)
],
v69 = [
  (v47/*: any*/)
],
v70 = {
  "kind": "InlineFragment",
  "selections": (v69/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v71 = {
  "kind": "ScalarField",
  "name": "picture"
},
v72 = {
  "kind": "ScalarField",
  "name": "email"
},
v73 = [
  {
    "kind": "ScalarField",
    "name": "jobTitle"
  }
],
v74 = {
  "args": [
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    }
  ],
  "concreteType": "SocialSignalSearch",
  "kind": "LinkedField",
  "name": "socialSignal",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "signal"
    },
    {
      "kind": "ScalarField",
      "name": "timestamp"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v46/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v63/*: any*/),
        (v71/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v72/*: any*/),
            {
              "concreteType": "AtlassianAccountUserExtendedProfile",
              "kind": "LinkedField",
              "name": "extendedProfile",
              "plural": false,
              "selections": (v73/*: any*/)
            }
          ],
          "type": "AtlassianAccountUser"
        },
        (v47/*: any*/)
      ]
    }
  ]
},
v75 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v64/*: any*/),
      "type": "ExternalRepository"
    },
    (v70/*: any*/)
  ]
},
v76 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v77 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v76/*: any*/),
        (v52/*: any*/),
        (v55/*: any*/)
      ],
      "type": "ExternalSpace"
    },
    (v70/*: any*/)
  ]
},
v78 = [
  {
    "kind": "ScalarField",
    "name": "reactionType"
  },
  (v66/*: any*/)
],
v79 = {
  "kind": "ScalarField",
  "name": "externalId"
},
v80 = {
  "concreteType": "ThirdPartyUserExtendedProfile",
  "kind": "LinkedField",
  "name": "extendedProfile",
  "plural": false,
  "selections": (v73/*: any*/)
},
v81 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": [
        (v63/*: any*/),
        (v72/*: any*/),
        (v71/*: any*/),
        (v79/*: any*/),
        (v80/*: any*/),
        (v47/*: any*/)
      ]
    }
  ]
},
v82 = [
  (v46/*: any*/),
  (v63/*: any*/),
  (v71/*: any*/),
  (v47/*: any*/)
],
v83 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v82/*: any*/)
},
v84 = {
  "kind": "ScalarField",
  "name": "status"
},
v85 = [
  (v76/*: any*/)
],
v86 = {
  "kind": "ScalarField",
  "name": "nickname"
},
v87 = {
  "concreteType": "ExternalAssociationConnection",
  "kind": "LinkedField",
  "name": "associatedWith",
  "plural": false,
  "selections": [
    {
      "concreteType": "ExternalAssociationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "ExternalAssociation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                (v46/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v79/*: any*/),
                    (v63/*: any*/),
                    (v86/*: any*/),
                    (v72/*: any*/),
                    (v71/*: any*/),
                    (v80/*: any*/),
                    (v47/*: any*/)
                  ],
                  "type": "ThirdPartyUser"
                },
                (v70/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "channelId",
                      "kind": "ScalarField",
                      "name": "externalId"
                    },
                    (v76/*: any*/)
                  ],
                  "type": "ExternalConversation"
                }
              ]
            },
            (v47/*: any*/)
          ]
        }
      ]
    }
  ]
},
v88 = {
  "kind": "ScalarField",
  "name": "thumbnailUrl"
},
v89 = [
  (v47/*: any*/),
  (v63/*: any*/),
  (v72/*: any*/),
  (v71/*: any*/),
  (v79/*: any*/),
  (v80/*: any*/)
],
v90 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": (v89/*: any*/)
    },
    {
      "condition": "__relay_internal__pv__skiplinkeduserhydrationrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
          "kind": "LinkedField",
          "name": "linkedUsers",
          "plural": false,
          "selections": [
            {
              "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v46/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v63/*: any*/),
                        (v71/*: any*/),
                        (v47/*: any*/)
                      ],
                      "type": "AtlassianAccountUser"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v69/*: any*/),
                      "type": "AppUser"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v69/*: any*/),
                      "type": "CustomerUser"
                    }
                  ]
                },
                (v47/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v91 = [
  (v47/*: any*/),
  (v63/*: any*/)
],
v92 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v91/*: any*/)
},
v93 = [
  (v92/*: any*/)
],
v94 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": (v93/*: any*/)
},
v95 = {
  "kind": "ScalarField",
  "name": "memberCount"
},
v96 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
},
v97 = [
  (v63/*: any*/),
  (v47/*: any*/)
],
v98 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v97/*: any*/)
},
v99 = [
  (v98/*: any*/)
],
v100 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "owners",
  "plural": true,
  "selections": (v99/*: any*/)
},
v101 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v99/*: any*/)
},
v102 = [
  (v46/*: any*/),
  (v63/*: any*/),
  (v47/*: any*/)
],
v103 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v102/*: any*/)
},
v104 = [
  (v46/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v47/*: any*/),
      (v76/*: any*/)
    ],
    "type": "ExternalCustomerOrg"
  },
  (v70/*: any*/)
],
v105 = {
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": (v104/*: any*/)
},
v106 = [
  {
    "kind": "ScalarField",
    "name": "lastActivityAt"
  },
  {
    "kind": "ScalarField",
    "name": "event"
  }
],
v107 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": (v93/*: any*/)
},
v108 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v93/*: any*/)
},
v109 = {
  "kind": "ScalarField",
  "name": "dueDate"
},
v110 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v111 = {
  "kind": "ScalarField",
  "name": "workspaceName"
},
v112 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v113 = {
  "kind": "ScalarField",
  "name": "eventEndTime"
},
v114 = {
  "kind": "ScalarField",
  "name": "eventStartTime"
},
v115 = {
  "kind": "ScalarField",
  "name": "videoMeetingUrl"
},
v116 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "allContributors",
  "plural": true,
  "selections": [
    (v63/*: any*/),
    (v86/*: any*/),
    (v72/*: any*/),
    (v71/*: any*/),
    (v79/*: any*/),
    (v80/*: any*/),
    (v47/*: any*/)
  ]
},
v117 = {
  "concreteType": "JiraProject",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": (v91/*: any*/)
},
v118 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v119 = [
  (v62/*: any*/),
  (v63/*: any*/),
  (v47/*: any*/)
],
v120 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v121 = [
  {
    "concreteType": "JiraLabelEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraLabel",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v64/*: any*/)
      }
    ]
  }
],
v122 = [
  (v54/*: any*/),
  (v62/*: any*/)
],
v123 = {
  "kind": "ScalarField",
  "name": "creatorName"
},
v124 = [
  (v61/*: any*/),
  (v76/*: any*/),
  (v47/*: any*/)
],
v125 = [
  {
    "kind": "ScalarField",
    "name": "targetDate"
  },
  {
    "kind": "ScalarField",
    "name": "targetDateType"
  }
],
v126 = [
  (v54/*: any*/)
],
v127 = {
  "concreteType": "AssetsLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "web"
    }
  ]
},
v128 = {
  "concreteType": "AssetsSchema",
  "kind": "LinkedField",
  "name": "objectSchemaEntity",
  "plural": false,
  "selections": [
    (v63/*: any*/),
    (v76/*: any*/),
    (v47/*: any*/)
  ]
},
v129 = [
  {
    "kind": "ScalarField",
    "name": "url48"
  }
],
v130 = [
  (v61/*: any*/),
  (v47/*: any*/)
],
v131 = {
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/),
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v47/*: any*/),
        (v49/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        (v50/*: any*/),
        (v51/*: any*/),
        (v52/*: any*/),
        (v53/*: any*/),
        (v48/*: any*/),
        (v54/*: any*/),
        (v55/*: any*/),
        (v56/*: any*/),
        (v57/*: any*/)
      ]
    },
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isSearchResult"
    },
    (v51/*: any*/),
    (v53/*: any*/),
    (v52/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "goal",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareStatus",
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareLocalizationField",
                  "kind": "LinkedField",
                  "name": "localizedLabel",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "messageId"
                    }
                  ]
                },
                (v58/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "score"
                }
              ]
            },
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "targetDate",
              "plural": false,
              "selections": (v60/*: any*/)
            },
            (v47/*: any*/),
            (v61/*: any*/),
            (v48/*: any*/)
          ]
        },
        (v62/*: any*/)
      ],
      "type": "SearchResultAtlasGoal"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "TownsquareProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isPrivate"
            },
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "dueDate",
              "plural": false,
              "selections": (v60/*: any*/)
            },
            {
              "concreteType": "TownsquareProjectState",
              "kind": "LinkedField",
              "name": "state",
              "plural": false,
              "selections": [
                (v59/*: any*/),
                (v58/*: any*/)
              ]
            },
            (v47/*: any*/),
            (v61/*: any*/)
          ]
        },
        (v62/*: any*/)
      ],
      "type": "SearchResultAtlasProject"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v54/*: any*/),
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            (v46/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "SearchFederatedEmailUser",
                  "kind": "LinkedField",
                  "name": "sender",
                  "plural": false,
                  "selections": (v64/*: any*/)
                }
              ],
              "type": "SearchFederatedEmailEntity"
            }
          ]
        }
      ],
      "type": "SearchResultFederated"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v54/*: any*/),
        {
          "kind": "ScalarField",
          "name": "tier"
        },
        {
          "concreteType": "CompassComponent",
          "kind": "LinkedField",
          "name": "component",
          "plural": false,
          "selections": [
            (v48/*: any*/),
            {
              "kind": "ScalarField",
              "name": "state"
            },
            (v47/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "ownerId"
        }
      ],
      "type": "SearchResultCompassComponent"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v65/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isVerified"
        },
        (v62/*: any*/),
        {
          "concreteType": "SearchConfluenceResultSpace",
          "kind": "LinkedField",
          "name": "space",
          "plural": false,
          "selections": [
            (v47/*: any*/),
            (v63/*: any*/),
            {
              "kind": "ScalarField",
              "name": "webUiLink"
            }
          ]
        },
        {
          "kind": "LinkedField",
          "name": "confluenceEntity",
          "plural": false,
          "selections": [
            (v46/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v55/*: any*/),
                {
                  "concreteType": "ConfluenceCommentCountSummary",
                  "kind": "LinkedField",
                  "name": "commentCountSummary",
                  "plural": false,
                  "selections": [
                    (v66/*: any*/)
                  ]
                },
                {
                  "concreteType": "ConfluenceLikesSummary",
                  "kind": "LinkedField",
                  "name": "likesSummary",
                  "plural": false,
                  "selections": (v68/*: any*/)
                }
              ],
              "type": "ConfluencePage"
            },
            (v70/*: any*/)
          ]
        },
        (v74/*: any*/),
        {
          "condition": "includeNavBoostScore",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "navBoostScore"
            }
          ]
        }
      ],
      "type": "SearchConfluencePageBlogAttachment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v62/*: any*/),
        (v65/*: any*/)
      ],
      "type": "SearchConfluenceSpace"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v57/*: any*/),
        (v50/*: any*/),
        (v56/*: any*/),
        (v55/*: any*/),
        (v54/*: any*/),
        {
          "kind": "ScalarField",
          "name": "permissionLevel"
        },
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            (v46/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v63/*: any*/),
                (v75/*: any*/)
              ],
              "type": "ExternalBranch"
            },
            (v70/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v77/*: any*/),
                {
                  "concreteType": "ExternalReaction",
                  "kind": "LinkedField",
                  "name": "reactionsV2",
                  "plural": true,
                  "selections": (v78/*: any*/)
                },
                (v81/*: any*/)
              ],
              "type": "ExternalComment"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "ExternalUser",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    (v83/*: any*/)
                  ]
                },
                (v75/*: any*/)
              ],
              "type": "ExternalCommit"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "container",
                  "plural": false,
                  "selections": [
                    (v46/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v76/*: any*/),
                        (v52/*: any*/)
                      ],
                      "type": "ExternalSpace"
                    },
                    (v70/*: any*/)
                  ]
                },
                {
                  "concreteType": "ExternalReaction",
                  "kind": "LinkedField",
                  "name": "reactions",
                  "plural": true,
                  "selections": (v78/*: any*/)
                },
                {
                  "condition": "includeThirdPartyId",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "thirdPartyId"
                    }
                  ]
                },
                (v84/*: any*/),
                {
                  "concreteType": "ExternalDocumentType",
                  "kind": "LinkedField",
                  "name": "type",
                  "plural": false,
                  "selections": [
                    (v62/*: any*/)
                  ]
                },
                {
                  "concreteType": "ExternalLargeContent",
                  "kind": "LinkedField",
                  "name": "nonIndexableContent",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "mediaThumbnailUrl"
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "name": "parent",
                  "plural": false,
                  "selections": [
                    (v46/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v85/*: any*/),
                      "type": "ExternalDocument"
                    },
                    (v70/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "commentCount"
                }
              ],
              "type": "ExternalDocument"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v79/*: any*/),
                (v87/*: any*/),
                (v48/*: any*/),
                {
                  "concreteType": "ExternalAttachment",
                  "kind": "LinkedField",
                  "name": "attachments",
                  "plural": true,
                  "selections": [
                    (v51/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "mimeType"
                    },
                    (v52/*: any*/),
                    (v88/*: any*/),
                    (v46/*: any*/)
                  ]
                },
                (v90/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "container",
                  "plural": false,
                  "selections": [
                    (v46/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v76/*: any*/),
                        (v94/*: any*/),
                        (v53/*: any*/),
                        (v47/*: any*/),
                        (v95/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "membershipType"
                        }
                      ],
                      "type": "ExternalConversation"
                    },
                    (v70/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "lastActive"
                },
                {
                  "kind": "ScalarField",
                  "name": "reactionCount"
                }
              ],
              "type": "ExternalMessage"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v48/*: any*/),
                (v76/*: any*/),
                (v95/*: any*/),
                {
                  "concreteType": "ExternalUser",
                  "kind": "LinkedField",
                  "name": "members",
                  "plural": true,
                  "selections": [
                    (v46/*: any*/)
                  ]
                }
              ],
              "type": "ExternalConversation"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v84/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "endDate"
                },
                (v96/*: any*/),
                (v100/*: any*/),
                (v101/*: any*/)
              ],
              "type": "ExternalCampaign"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "displayNumber"
                },
                (v84/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "closedAt"
                },
                (v96/*: any*/),
                {
                  "concreteType": "ExternalUser",
                  "kind": "LinkedField",
                  "name": "owners",
                  "plural": true,
                  "selections": [
                    (v98/*: any*/),
                    (v103/*: any*/)
                  ]
                },
                (v101/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "container",
                  "plural": false,
                  "selections": (v104/*: any*/)
                }
              ],
              "type": "ExternalCase"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v76/*: any*/),
                (v100/*: any*/),
                (v105/*: any*/),
                {
                  "concreteType": "ExternalCustomerOrgLastActivity",
                  "kind": "LinkedField",
                  "name": "customerOrgLastActivity",
                  "plural": false,
                  "selections": (v106/*: any*/)
                }
              ],
              "type": "ExternalCustomerOrg"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "stage"
                },
                {
                  "kind": "ScalarField",
                  "name": "dealClosedAt"
                },
                {
                  "concreteType": "ExternalDealLastActivity",
                  "kind": "LinkedField",
                  "name": "lastActivity",
                  "plural": false,
                  "selections": (v106/*: any*/)
                },
                (v100/*: any*/),
                (v105/*: any*/)
              ],
              "type": "ExternalDeal"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v77/*: any*/),
                (v107/*: any*/),
                (v108/*: any*/),
                (v109/*: any*/),
                (v61/*: any*/),
                (v84/*: any*/)
              ],
              "type": "ExternalProject"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v77/*: any*/),
                (v107/*: any*/),
                (v108/*: any*/),
                (v109/*: any*/),
                (v84/*: any*/),
                (v55/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "team"
                },
                {
                  "concreteType": "ExternalWorkItemProject",
                  "kind": "LinkedField",
                  "name": "workItemProject",
                  "plural": false,
                  "selections": (v91/*: any*/)
                },
                {
                  "concreteType": "ExternalProvider",
                  "kind": "LinkedField",
                  "name": "provider",
                  "plural": false,
                  "selections": (v64/*: any*/)
                }
              ],
              "type": "ExternalWorkItem"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v51/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "lastUpdate"
                },
                {
                  "kind": "ScalarField",
                  "name": "pullRequestId"
                },
                {
                  "alias": "pullRequestStatus",
                  "kind": "ScalarField",
                  "name": "status"
                },
                (v75/*: any*/)
              ],
              "type": "ExternalPullRequest"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "durationInSeconds"
                },
                {
                  "kind": "ScalarField",
                  "name": "embedUrl"
                },
                {
                  "condition": "__relay_internal__pv__ismetadatacontentenabledrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "concreteType": "ExternalMetadataContentLink",
                      "kind": "LinkedField",
                      "name": "metadataContentLinks",
                      "plural": true,
                      "selections": [
                        (v52/*: any*/)
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "metadataContentUrl"
                    }
                  ]
                },
                (v88/*: any*/),
                {
                  "concreteType": "ExternalEntityExtendedValue",
                  "kind": "LinkedField",
                  "name": "entityExtendedValues",
                  "plural": true,
                  "selections": [
                    (v110/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "fieldValue"
                    },
                    {
                      "concreteType": "ExternalEntityExtendedValueDisplayName",
                      "kind": "LinkedField",
                      "name": "fieldDisplayName",
                      "plural": false,
                      "selections": (v85/*: any*/)
                    },
                    {
                      "kind": "ScalarField",
                      "name": "isDisplayed"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "dataType"
                    }
                  ]
                },
                {
                  "concreteType": "ExternalChapter",
                  "kind": "LinkedField",
                  "name": "chapters",
                  "plural": true,
                  "selections": [
                    (v51/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "startTimeInSeconds"
                    }
                  ]
                },
                {
                  "concreteType": "ExternalUser",
                  "kind": "LinkedField",
                  "name": "createdBy",
                  "plural": false,
                  "selections": [
                    (v92/*: any*/),
                    (v103/*: any*/)
                  ]
                }
              ],
              "type": "ExternalVideo"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v47/*: any*/),
                (v52/*: any*/),
                (v111/*: any*/),
                (v100/*: any*/)
              ],
              "type": "ExternalDashboard"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v47/*: any*/),
                (v52/*: any*/),
                {
                  "alias": "dataTableType",
                  "kind": "ScalarField",
                  "name": "type"
                },
                (v111/*: any*/),
                (v100/*: any*/)
              ],
              "type": "ExternalDataTable"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "accountName"
                },
                {
                  "concreteType": "ExternalUser",
                  "kind": "LinkedField",
                  "name": "contactUser",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "ThirdPartyUser",
                      "kind": "LinkedField",
                      "name": "thirdPartyUser",
                      "plural": false,
                      "selections": [
                        (v63/*: any*/),
                        (v80/*: any*/),
                        (v47/*: any*/)
                      ]
                    }
                  ]
                }
              ],
              "type": "ExternalCustomerContact"
            }
          ]
        },
        (v112/*: any*/),
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            (v46/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v108/*: any*/),
                (v113/*: any*/),
                (v114/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "recurringEventId"
                },
                (v115/*: any*/)
              ],
              "type": "ExternalCalendarEvent"
            },
            (v70/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "ExternalThumbnail",
                  "kind": "LinkedField",
                  "name": "thumbnail",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "externalUrl"
                    }
                  ]
                }
              ],
              "type": "ExternalDesign"
            }
          ]
        },
        {
          "concreteType": "SearchResultGraphDocument",
          "kind": "LinkedField",
          "name": "linkedEntities",
          "plural": true,
          "selections": [
            (v47/*: any*/),
            (v51/*: any*/),
            (v52/*: any*/),
            {
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                (v46/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v114/*: any*/),
                    (v113/*: any*/),
                    (v115/*: any*/)
                  ],
                  "type": "ExternalCalendarEvent"
                },
                (v70/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v76/*: any*/),
                    (v81/*: any*/)
                  ],
                  "type": "ExternalComment"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v90/*: any*/),
                    {
                      "kind": "LinkedField",
                      "name": "container",
                      "plural": false,
                      "selections": [
                        (v46/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v94/*: any*/),
                            (v53/*: any*/)
                          ],
                          "type": "ExternalConversation"
                        },
                        (v70/*: any*/)
                      ]
                    },
                    (v79/*: any*/),
                    (v87/*: any*/),
                    (v48/*: any*/)
                  ],
                  "type": "ExternalMessage"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v48/*: any*/)
                  ],
                  "type": "ExternalConversation"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "parentId"
            },
            (v112/*: any*/),
            {
              "concreteType": "ThirdPartyUser",
              "kind": "LinkedField",
              "name": "initialContributors",
              "plural": true,
              "selections": (v89/*: any*/)
            },
            (v56/*: any*/),
            (v116/*: any*/)
          ]
        },
        {
          "concreteType": "ThirdPartyUser",
          "kind": "LinkedField",
          "name": "initialContributors",
          "plural": true,
          "selections": [
            (v63/*: any*/),
            (v71/*: any*/),
            (v47/*: any*/),
            (v72/*: any*/),
            (v79/*: any*/),
            (v80/*: any*/)
          ]
        },
        {
          "concreteType": "SearchResultGraphTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "tabId"
            },
            (v51/*: any*/),
            (v52/*: any*/),
            (v46/*: any*/)
          ]
        },
        (v111/*: any*/),
        {
          "concreteType": "SearchResultGraphAttachment",
          "kind": "LinkedField",
          "name": "attachments",
          "plural": true,
          "selections": [
            (v51/*: any*/),
            {
              "kind": "ScalarField",
              "name": "fileType"
            },
            (v52/*: any*/),
            (v46/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "containerName"
        },
        {
          "concreteType": "ThirdPartyUser",
          "kind": "LinkedField",
          "name": "allContributors",
          "plural": true,
          "selections": (v91/*: any*/)
        },
        (v116/*: any*/),
        {
          "kind": "ScalarField",
          "name": "links"
        },
        {
          "kind": "ScalarField",
          "name": "linkedEntitiesType"
        },
        {
          "kind": "ScalarField",
          "name": "connectorId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorProduct"
        },
        (v49/*: any*/),
        {
          "condition": "includeOriginalEntityType",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "originalEntityType"
            }
          ]
        },
        {
          "condition": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isSharedChannel"
            }
          ]
        },
        {
          "condition": "__relay_internal__pv__isleadnounenabledrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v84/*: any*/),
                    (v96/*: any*/),
                    {
                      "condition": "__relay_internal__pv__isleaduserastitleenabledrelayprovider",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        {
                          "concreteType": "ExternalUser",
                          "kind": "LinkedField",
                          "name": "leadUser",
                          "plural": false,
                          "selections": (v99/*: any*/)
                        }
                      ]
                    },
                    (v100/*: any*/),
                    (v101/*: any*/)
                  ],
                  "type": "ExternalLead"
                }
              ]
            }
          ]
        },
        {
          "condition": "__relay_internal__pv__isslacktopreactionenabledrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "SearchSlackReaction",
              "kind": "LinkedField",
              "name": "topReaction",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "emojiName"
                },
                {
                  "kind": "ScalarField",
                  "name": "emojiUrl"
                },
                (v67/*: any*/)
              ]
            }
          ]
        }
      ],
      "type": "SearchResultGraphDocument"
    },
    {
      "condition": "includeCodeSearch",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "path"
            },
            {
              "kind": "ScalarField",
              "name": "language"
            },
            (v54/*: any*/),
            {
              "concreteType": "SearchResultCodeChunk",
              "kind": "LinkedField",
              "name": "matchedChunks",
              "plural": true,
              "selections": [
                (v47/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "sourceCode"
                },
                {
                  "concreteType": "SearchResultCodeLineRange",
                  "kind": "LinkedField",
                  "name": "lineRange",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "start"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "matchedRanges"
                }
              ]
            },
            {
              "concreteType": "SearchResultCodeRepository",
              "kind": "LinkedField",
              "name": "repository",
              "plural": false,
              "selections": [
                (v63/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "namespace"
                },
                (v52/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "scm"
                },
                (v47/*: any*/)
              ]
            }
          ],
          "type": "SearchResultGraphCode"
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v54/*: any*/),
        (v62/*: any*/),
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            {
              "condition": "includeFastJiraHydration",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "issueTypeAvatarUrl"
                },
                {
                  "concreteType": "JiraIssueTypeField",
                  "kind": "LinkedField",
                  "name": "issueTypeField",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueType",
                      "kind": "LinkedField",
                      "name": "issueType",
                      "plural": false,
                      "selections": (v97/*: any*/)
                    },
                    (v47/*: any*/)
                  ]
                },
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "ids",
                      "value": [
                        "project"
                      ]
                    }
                  ],
                  "concreteType": "JiraIssueFieldConnection",
                  "kind": "LinkedField",
                  "name": "fieldsById",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v46/*: any*/),
                            (v63/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v117/*: any*/)
                              ],
                              "type": "JiraProjectField"
                            },
                            (v47/*: any*/)
                          ]
                        }
                      ]
                    }
                  ],
                  "storageKey": "fieldsById(ids:[\"project\"])"
                },
                {
                  "concreteType": "JiraSingleSelectUserPickerField",
                  "kind": "LinkedField",
                  "name": "assigneeField",
                  "plural": false,
                  "selections": [
                    (v83/*: any*/),
                    (v47/*: any*/)
                  ]
                }
              ]
            },
            (v118/*: any*/),
            (v61/*: any*/),
            {
              "condition": "includeFastJiraHydration",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "issueType",
                  "plural": false,
                  "selections": [
                    (v63/*: any*/),
                    {
                      "concreteType": "JiraAvatar",
                      "kind": "LinkedField",
                      "name": "avatar",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "medium"
                        }
                      ]
                    },
                    (v47/*: any*/)
                  ]
                },
                (v117/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "assignee",
                  "plural": false,
                  "selections": (v82/*: any*/)
                },
                {
                  "condition": "includeJiraLiteModeFields",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": "fastPriority",
                      "concreteType": "JiraPriority",
                      "kind": "LinkedField",
                      "name": "priority",
                      "plural": false,
                      "selections": (v119/*: any*/)
                    },
                    {
                      "alias": "fastLabels",
                      "args": (v120/*: any*/),
                      "concreteType": "JiraLabelConnection",
                      "kind": "LinkedField",
                      "name": "labels",
                      "plural": false,
                      "selections": (v121/*: any*/),
                      "storageKey": "labels(first:5)"
                    }
                  ]
                }
              ]
            },
            {
              "condition": "includeJiraLiteModeFields",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "condition": "includeFastJiraHydration",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "concreteType": "JiraPriorityField",
                      "kind": "LinkedField",
                      "name": "priorityField",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraPriority",
                          "kind": "LinkedField",
                          "name": "priority",
                          "plural": false,
                          "selections": (v119/*: any*/)
                        },
                        (v47/*: any*/)
                      ]
                    },
                    {
                      "concreteType": "JiraLabelsField",
                      "kind": "LinkedField",
                      "name": "labelsField",
                      "plural": false,
                      "selections": [
                        {
                          "args": (v120/*: any*/),
                          "concreteType": "JiraLabelConnection",
                          "kind": "LinkedField",
                          "name": "selectedLabelsConnection",
                          "plural": false,
                          "selections": (v121/*: any*/),
                          "storageKey": "selectedLabelsConnection(first:5)"
                        },
                        (v47/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            },
            (v47/*: any*/)
          ]
        }
      ],
      "type": "SearchResultJiraIssue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "projectKey"
        },
        (v54/*: any*/),
        (v62/*: any*/),
        {
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v118/*: any*/),
            {
              "condition": "includeJiraLiteModeFields",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "lead",
                  "plural": false,
                  "selections": (v82/*: any*/)
                },
                {
                  "concreteType": "JiraAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "small"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "projectStyle"
                },
                {
                  "kind": "ScalarField",
                  "name": "projectType"
                },
                {
                  "concreteType": "JiraProjectCategory",
                  "kind": "LinkedField",
                  "name": "category",
                  "plural": false,
                  "selections": (v97/*: any*/)
                }
              ]
            },
            (v47/*: any*/)
          ]
        },
        (v74/*: any*/)
      ],
      "type": "SearchResultJiraProject"
    },
    {
      "kind": "InlineFragment",
      "selections": (v122/*: any*/),
      "type": "SearchResultJiraPlan"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v54/*: any*/),
        (v62/*: any*/),
        {
          "concreteType": "JiraBoard",
          "kind": "LinkedField",
          "name": "board",
          "plural": false,
          "selections": [
            (v62/*: any*/),
            {
              "kind": "ScalarField",
              "name": "boardFrontendUrl"
            },
            (v47/*: any*/)
          ]
        }
      ],
      "type": "SearchResultJiraBoard"
    },
    {
      "kind": "InlineFragment",
      "selections": (v122/*: any*/),
      "type": "SearchResultJiraDashboard"
    },
    {
      "kind": "InlineFragment",
      "selections": (v122/*: any*/),
      "type": "SearchResultJiraFilter"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "totalNestedVideos"
        }
      ],
      "type": "SearchResultLoomFolder"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v123/*: any*/)
      ],
      "type": "SearchResultLoomPlaylist"
    },
    {
      "kind": "InlineFragment",
      "selections": (v68/*: any*/),
      "type": "SearchResultLoomTag"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "durationSeconds"
        },
        (v123/*: any*/)
      ],
      "type": "SearchResultLoomVideo"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "MercuryFocusArea",
          "kind": "LinkedField",
          "name": "focusArea",
          "plural": false,
          "selections": [
            {
              "concreteType": "MercuryFocusAreaStatus",
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": (v124/*: any*/)
            },
            {
              "concreteType": "MercuryFocusAreaHealth",
              "kind": "LinkedField",
              "name": "health",
              "plural": false,
              "selections": [
                (v61/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "color"
                },
                (v76/*: any*/),
                (v47/*: any*/)
              ]
            },
            {
              "concreteType": "MercuryTargetDate",
              "kind": "LinkedField",
              "name": "targetDate",
              "plural": false,
              "selections": (v125/*: any*/)
            },
            (v47/*: any*/),
            (v63/*: any*/),
            {
              "concreteType": "MercuryFocusAreaType",
              "kind": "LinkedField",
              "name": "focusAreaType",
              "plural": false,
              "selections": (v91/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": (v102/*: any*/)
            }
          ]
        },
        (v54/*: any*/)
      ],
      "type": "SearchResultMercuryFocusArea"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v54/*: any*/),
        {
          "concreteType": "MercuryFocusArea",
          "kind": "LinkedField",
          "name": "focusArea",
          "plural": false,
          "selections": (v97/*: any*/)
        }
      ],
      "type": "SearchResultMercuryFocusAreaStatusUpdate"
    },
    {
      "condition": "includeRisk",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v54/*: any*/),
            {
              "concreteType": "MercuryRisk",
              "kind": "LinkedField",
              "name": "risk",
              "plural": false,
              "selections": [
                {
                  "concreteType": "MercuryRiskStatus",
                  "kind": "LinkedField",
                  "name": "status",
                  "plural": false,
                  "selections": (v124/*: any*/)
                },
                {
                  "concreteType": "MercuryRiskTargetDate",
                  "kind": "LinkedField",
                  "name": "targetDate",
                  "plural": false,
                  "selections": (v125/*: any*/)
                },
                (v47/*: any*/)
              ]
            }
          ],
          "type": "SearchResultMercuryRisk"
        }
      ]
    },
    {
      "condition": "includeMercuryAsk",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v54/*: any*/),
            {
              "alias": "mercuryAsk",
              "concreteType": "MercuryAsk",
              "kind": "LinkedField",
              "name": "ask",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "askStatus"
                },
                {
                  "concreteType": "MercuryAskTargetDate",
                  "kind": "LinkedField",
                  "name": "targetDate",
                  "plural": false,
                  "selections": (v125/*: any*/)
                },
                (v47/*: any*/)
              ]
            }
          ],
          "type": "SearchResultMercuryAsk"
        }
      ]
    },
    {
      "condition": "includePassionfruitAsk",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "SpfAsk",
              "kind": "LinkedField",
              "name": "ask",
              "plural": false,
              "selections": [
                (v84/*: any*/),
                {
                  "concreteType": "SpfAskTargetDate",
                  "kind": "LinkedField",
                  "name": "targetDate",
                  "plural": false,
                  "selections": (v125/*: any*/)
                },
                (v47/*: any*/)
              ]
            },
            (v54/*: any*/)
          ],
          "type": "SearchResultSpfAsk"
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": (v126/*: any*/),
      "type": "SearchResultTrelloBoard"
    },
    {
      "kind": "InlineFragment",
      "selections": (v126/*: any*/),
      "type": "SearchResultTrelloCard"
    },
    {
      "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v54/*: any*/),
            {
              "concreteType": "AssetsSchema",
              "kind": "LinkedField",
              "name": "objectSchemaEntity",
              "plural": false,
              "selections": [
                (v63/*: any*/),
                (v76/*: any*/),
                (v127/*: any*/),
                (v47/*: any*/)
              ]
            }
          ],
          "type": "SearchResultAssetsObjectSchema"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v54/*: any*/),
            (v128/*: any*/),
            {
              "concreteType": "AssetsObjectType",
              "kind": "LinkedField",
              "name": "objectTypeEntity",
              "plural": false,
              "selections": [
                (v63/*: any*/),
                (v76/*: any*/),
                {
                  "concreteType": "AssetsIcon",
                  "kind": "LinkedField",
                  "name": "icon",
                  "plural": false,
                  "selections": (v129/*: any*/)
                },
                (v127/*: any*/),
                (v47/*: any*/)
              ]
            }
          ],
          "type": "SearchResultAssetsObjectType"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v54/*: any*/),
            (v128/*: any*/),
            {
              "concreteType": "AssetsObject",
              "kind": "LinkedField",
              "name": "objectEntity",
              "plural": false,
              "selections": [
                {
                  "concreteType": "AssetsAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": (v129/*: any*/)
                },
                (v127/*: any*/),
                (v47/*: any*/)
              ]
            }
          ],
          "type": "SearchResultAssetsObject"
        }
      ]
    },
    {
      "condition": "includePositions",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "RadarPosition",
              "kind": "LinkedField",
              "name": "position",
              "plural": false,
              "selections": [
                (v46/*: any*/),
                {
                  "concreteType": "RadarWorker",
                  "kind": "LinkedField",
                  "name": "worker",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "preferredName"
                    },
                    {
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        (v46/*: any*/),
                        (v71/*: any*/),
                        (v47/*: any*/)
                      ]
                    },
                    (v47/*: any*/)
                  ]
                },
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "fieldIdIsIn",
                      "value": [
                        "positionId",
                        "positionStatus",
                        "positionJobTitle",
                        "positionPositionTitle",
                        "positionKey",
                        "positionExternalPositionKey",
                        "positionWorker",
                        "focusArea"
                      ]
                    }
                  ],
                  "concreteType": "RadarFieldValueIdPair",
                  "kind": "LinkedField",
                  "name": "fieldValues",
                  "plural": true,
                  "selections": [
                    (v110/*: any*/),
                    {
                      "kind": "LinkedField",
                      "name": "fieldValue",
                      "plural": false,
                      "selections": [
                        (v46/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": "stringValue",
                              "kind": "ScalarField",
                              "name": "value"
                            }
                          ],
                          "type": "RadarStringFieldValue"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "value",
                              "plural": false,
                              "selections": [
                                (v46/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v63/*: any*/),
                                    {
                                      "concreteType": "MercuryFocusAreaStatus",
                                      "kind": "LinkedField",
                                      "name": "status",
                                      "plural": false,
                                      "selections": (v130/*: any*/)
                                    },
                                    {
                                      "concreteType": "MercuryFocusAreaHealth",
                                      "kind": "LinkedField",
                                      "name": "health",
                                      "plural": false,
                                      "selections": (v130/*: any*/)
                                    }
                                  ],
                                  "type": "MercuryFocusArea"
                                },
                                (v70/*: any*/)
                              ]
                            }
                          ],
                          "type": "RadarAriFieldValue"
                        }
                      ]
                    }
                  ],
                  "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                },
                (v47/*: any*/)
              ]
            }
          ],
          "type": "SearchResultTalentPosition"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v43/*: any*/)
    ],
    "kind": "Fragment",
    "name": "searchResultsAsyncQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "deferFederatedResults",
            "variableName": "deferFederatedResults"
          },
          {
            "kind": "Variable",
            "name": "includeCaseEmbeddedComments",
            "variableName": "includeCaseEmbeddedComments"
          },
          {
            "kind": "Variable",
            "name": "includeCodeSearch",
            "variableName": "includeCodeSearch"
          },
          {
            "kind": "Variable",
            "name": "includeDatasourceId",
            "variableName": "includeDatasourceId"
          },
          {
            "kind": "Variable",
            "name": "includeFastJiraHydration",
            "variableName": "includeFastJiraHydration"
          },
          {
            "kind": "Variable",
            "name": "includeJiraLiteModeFields",
            "variableName": "includeJiraLiteModeFields"
          },
          {
            "kind": "Variable",
            "name": "includeMercuryAsk",
            "variableName": "includeMercuryAsk"
          },
          {
            "kind": "Variable",
            "name": "includeNavBoostScore",
            "variableName": "includeNavBoostScore"
          },
          {
            "kind": "Variable",
            "name": "includeOriginalEntityType",
            "variableName": "includeOriginalEntityType"
          },
          {
            "kind": "Variable",
            "name": "includePassionfruitAsk",
            "variableName": "includePassionfruitAsk"
          },
          {
            "kind": "Variable",
            "name": "includePositions",
            "variableName": "includePositions"
          },
          {
            "kind": "Variable",
            "name": "includeRisk",
            "variableName": "includeRisk"
          },
          {
            "kind": "Variable",
            "name": "includeThirdPartyId",
            "variableName": "includeThirdPartyId"
          },
          (v44/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v33/*: any*/),
      (v2/*: any*/),
      (v41/*: any*/),
      (v29/*: any*/),
      (v10/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v28/*: any*/),
      (v30/*: any*/),
      (v1/*: any*/),
      (v32/*: any*/),
      (v40/*: any*/),
      (v4/*: any*/),
      (v42/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v13/*: any*/),
      (v37/*: any*/),
      (v14/*: any*/),
      (v31/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v12/*: any*/),
      (v43/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v15/*: any*/),
      (v11/*: any*/),
      (v25/*: any*/),
      (v27/*: any*/),
      (v18/*: any*/),
      (v23/*: any*/),
      (v22/*: any*/),
      (v24/*: any*/),
      (v26/*: any*/),
      (v21/*: any*/),
      (v20/*: any*/),
      (v19/*: any*/),
      (v17/*: any*/),
      (v16/*: any*/),
      (v6/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isassetsenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isleadnounenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isleaduserastitleenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isslacktopreactionenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__skiplinkeduserhydrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isprojectrendererenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__ismetadatacontentenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "searchResultsAsyncQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "alias": "search",
            "args": (v45/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "asyncSearch",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isCachedResult"
              },
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "excludeFederated",
                    "variableName": "deferFederatedResults"
                  }
                ],
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v131/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "SearchQueryInfo",
                "kind": "LinkedField",
                "name": "queryInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "originalQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "replacementQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "suggestedQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "originalQueryType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "confidenceScore"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "shouldTriggerAutocorrectionExperience"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "traceId"
              },
              {
                "concreteType": "SearchError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "product"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "integration"
                  }
                ]
              },
              {
                "condition": "deferFederatedResults",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "if": "deferFederatedResults",
                    "kind": "Defer",
                    "label": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$defer$searchResultsAsyncQuery_federatedEdges",
                    "selections": [
                      {
                        "concreteType": "SearchResultItemEdge",
                        "kind": "LinkedField",
                        "name": "federatedEdges",
                        "plural": true,
                        "selections": [
                          (v131/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "search",
            "args": (v45/*: any*/),
            "filters": [
              "experience",
              "useCaseId",
              "enableHighlighting",
              "enableRelevanceDebugging",
              "query",
              "sort",
              "disableQueryReplacement",
              "fanoutExperimentCohort",
              "expectResult",
              "filters",
              "analytics",
              "experimentContext",
              "matchingLayerExperimentsMetadata"
            ],
            "handle": "connection",
            "key": "SearchResultsAsyncPagination__search",
            "kind": "LinkedHandle",
            "name": "asyncSearch"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "929cb40c8421910923cc1b654f8601af59d22ab4f38d19384d91ed4677abf87a",
    "metadata": {},
    "name": "searchResultsAsyncQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
      "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider": includeSlackWorkspaceMetadata_provider,
      "__relay_internal__pv__isleadnounenabledrelayprovider": isLeadNounEnabled_provider,
      "__relay_internal__pv__isleaduserastitleenabledrelayprovider": isLeadUserAsTitleEnabled_provider,
      "__relay_internal__pv__isslacktopreactionenabledrelayprovider": includeSlackTopReaction_provider,
      "__relay_internal__pv__skiplinkeduserhydrationrelayprovider": skipLinkedUserHydration_provider,
      "__relay_internal__pv__isprojectrendererenabledrelayprovider": isProjectRendererEnabled_provider,
      "__relay_internal__pv__ismetadatacontentenabledrelayprovider": includeMetadataContent_provider
    }
  }
};
})();

(node as any).hash = "fad4de463f6d4024abcc5d6e2b3ebedd";

export default node;
